'use client'

import * as React from 'react'

interface PromptInputContextValue {
  isLoading: boolean
  value: string
  setValue: (value: string) => void
  maxHeight: number | string
  onSubmit?: () => void
  disabled?: boolean
}

const PromptInputContext = React.createContext<PromptInputContextValue | null>(null)

export function PromptInputProvider({
  value,
  children
}: {
  value: PromptInputContextValue
  children: React.ReactNode
}) {
  return <PromptInputContext.Provider value={value}>{children}</PromptInputContext.Provider>
}

export function usePromptInput() {
  const context = React.useContext(PromptInputContext)
  if (!context) {
    throw new Error('usePromptInput must be used within a PromptInputProvider')
  }
  return context
}

export type { PromptInputContextValue }
